import { useEffect } from 'react';
import styled from 'styled-components';
import { RenderViewImpactChartParams } from '../../../../../common/renderer/component-types/types-render-view-impact-chart';
import { RenderViewComponentType } from '../../../../../common/renderer/types';
import { NetImpactChartPlain } from '../../../../common/upright/model/output/scores/net-impact-chart';
import { useRenderViewContext } from '../../context';
import { useGetRenderViewComponentParamSetter } from '../../context/component-param-setter';
import { toChartData } from '../../utils';
import { RenderViewLegendTable } from './legend';

export function RenderViewImpactChart(props: { width: number; params: RenderViewImpactChartParams }) {
  const context = useRenderViewContext();

  // TODO OA: Change to fetch own data with ReactQuery instead of getting it from RenderViewContext
  const { data, options, getNameOfFirstItem } = context;
  const { width, params } = props;
  const items = options.items;

  const setParams = useGetRenderViewComponentParamSetter(RenderViewComponentType.IMPACT_CHART);

  useEffect(() => {
    if (data && params.chartTitle === undefined) {
      setParams(prevParams => {
        return {
          ...prevParams,
          chartTitle: getNameOfFirstItem(),
        };
      });
    }
  }, [data, getNameOfFirstItem, params.chartTitle, setParams]);

  if (!items || !data) {
    return <></>;
  }

  const impactChartData = toChartData(items, data);

  const {
    noLeftMargin,
    negativeColor,
    positiveColor,
    language,
    simplify,
    showValueChains,
    hideTitle,
    chartTitle,
    hideNetScore,
    scoreType,
  } = params;

  return (
    <Root>
      {params.showLegend && <RenderViewLegendTable params={params} />}
      <StyledImpactChart
        noLeftMargin={noLeftMargin}
        negativeColor={negativeColor}
        positiveColor={positiveColor}
        language={language}
        simplify={simplify}
        expandedOnDefault={props.params.isExpanded}
        staticMode={true}
        showValueChains={showValueChains}
        onShowValueChainsChange={newValue => {
          setParams(curr => ({ ...curr, showValueChains: newValue }));
        }}
        hideTitle={hideTitle}
        bigFonts={options.isShareImg}
        title={chartTitle}
        width={width}
        hideValueChainsSwitch
        data={impactChartData}
        hideNetScore={hideNetScore}
        scoreTypeOverride={scoreType}
        onScoreTypeChange={newScoreType => {
          setParams(curr => ({ ...curr, scoreType: newScoreType }));
        }}
        onExpandedChange={(dimension, newExpanded) => {
          const currentExpanded = props.params.isExpanded;
          const updatedExpanded = (() => {
            if (!currentExpanded) {
              return newExpanded ? [dimension] : undefined;
            }
            switch (newExpanded) {
              case true:
                return currentExpanded.includes(dimension) ? currentExpanded : [...currentExpanded, dimension];
              case false:
                return currentExpanded.filter(d => d !== dimension);
            }
          })();
          setParams(curr => ({ ...curr, isExpanded: updatedExpanded }));
        }}
        version={options.version}
        alignLineEdges
        showRenderViewButton={false}
      />
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  & > * + * {
    margin-top: 60px;
  }
`;

const StyledImpactChart = styled(NetImpactChartPlain)<{ noLeftMargin: boolean | undefined }>`
  ${props => props.noLeftMargin && 'margin-left: 0;'}
`;
